import sortByString from '../helpers/helpers';
import { getLinkId } from '../forms/formHelpers';

export const toConnectionValue = (type, id) => {
  if (!type || !id) return undefined;
  return `${type}:${id}`;
};

export const getConnectionOptions = (contacts, type, divisions = []) => {
  const divisionSet = new Set(divisions);
  return Object.values(contacts)
    .filter((contact) => (
      contact?.active
      && contact.id
      && contact.name
      && contact.divisionIds?.some((divisionId) => divisionSet.has(divisionId))
    ))
    .map(({ id, name: contactName }) => ({
      label: contactName,
      value: toConnectionValue(type, id),
    }))
    .sort(sortByString('label'));
};

const getLinkedContactDropdownType = (sections, linkField) => {
  if (!sections || !linkField) return null;
  let linkedType = null;
  sections.forEach((section) => {
    const fields = section?.fields ?? [];
    fields.forEach((field) => {
      if (field?.id === linkField) {
        linkedType = field.configProps?.dataType;
      }
    });
  });
  return linkedType;
};

export const getInitialConnection = ({ sections, linkField, responses }) => {
  const linkedDropdownType = getLinkedContactDropdownType(sections, linkField);
  const linkedSelectionId = linkField
    ? getLinkId({ responses, defaultValue: null, linkField })
    : null;

  if (linkedDropdownType === 'Customers') {
    return toConnectionValue('customer', linkedSelectionId);
  }
  if (linkedDropdownType === 'Vendors') {
    return toConnectionValue('vendor', linkedSelectionId);
  }
  return undefined;
};